import {areaJson} from './area'
import { provinceAndCityData, regionData, provinceAndCityDataPlus, regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'

export const mixins = {
    created() {
    },
    data() {
        return {
            areaJson,
            provinceAndCityData,
            regionData,
            provinceAndCityDataPlus,
            regionDataPlus,
            CodeToText,
            TextToCode,
        }
    }
}
